import { useQuery } from '@apollo/client';
import { GetComplianceMonitoringAssessmentByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import type { FC } from 'react';

type Props = {
  assessmentId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ assessmentId }) => {
  if (!assessmentId) {
    throw new Error('Missing assessmentId param');
  }
  const { data } = useQuery(GetComplianceMonitoringAssessmentByIdDocument, {
    variables: {
      Id: assessmentId,
    },
  });

  return <>{data?.compliance_monitoring_assessment?.[0]?.Title || ''}</>;
};

export default Breadcrumb;
